'use strict';

const Mn = require('backbone.marionette');
const TaskCollectionRepository = require('my/domain/repository/task-collection');
const CountBadgeTemplate = require('common/ui/template/count-badge.hbs');
const Template = require('./task.hbs');

const ReviewCount = Mn.View.extend({
    tagName: 'span',
    template: CountBadgeTemplate,
    serializeData: function () {
        const count = this.getOption('count');
        return {
            count: count < 100 ? count : '99+'
        };
    }
});

module.exports = Mn.View.extend({
    tagName: 'div',
    template: Template,
    events: {
        'click': 'toggle'
    },
    regions: {
        taskCount: '.task-count',
    },

    onRender: function() {
        // this.listenTo(tasks, 'add remove change:read reset', this.renderTaskCount);

        this.renderTaskCount();
    },

    toggle: function() {
        this.triggerMethod('toggle:task');
    },

    renderTaskCount: function() {
        TaskCollectionRepository.my()
            .fetchFirstPage(10)
            .then(tasks => {
                this.showChildView('taskCount', new ReviewCount({
                    count: tasks.getTotalCount()
                }));
            });
    },

    activate: function() {
        this.$('.menu-icon').addClass('is-active');
    },

    deactivate: function() {
        this.$('.menu-icon').removeClass('is-active');
    }
});



// WEBPACK FOOTER //
// ./my/ui/header/task.js